import CardsFilters from './filters_cards';

const FilterData = { ...CardsFilters };

export default FilterData;
